import React from 'react';
import { LocalisationContext } from "providers/LocalisationProvider";
import HtmlParse from 'html-react-parser';
import { isProductionDeployment, targetLabel } from "helpers/environment";

const BUILD_LABELS = {
    LOCAL: "Local",
    STAGING: "Staging",
    PRODUCTION: "Production",
};

// Colour tracks the target, not the build - the target is where the data lives,
// so it is what determines how much damage a mistake here can do. An
// unrecognised target is treated as dangerous rather than assumed safe.
const TARGET_STYLES = {
    Emulator: "env-emulator",
    Staging: "env-staging",
    Production: "env-production",
};

export default class InDevNotification extends React.Component {
    static contextType = LocalisationContext;

    render() {
        const environment = import.meta.env.VITE_ENVIRONMENT;
        const projectId = import.meta.env.VITE_FIREBASE_PROJECT_ID;

        // Only a correct production deployment is unmarked - the absence of a
        // banner is the indicator. Testing the pair rather than the build alone
        // is what keeps a production bundle wired to staging visible; that case
        // used to fall through this return and show nothing at all.
        //
        // Local and staging stay banded even when correctly paired, because
        // several tabs open against different environments is the normal way to
        // work and the colour is how you tell them apart at a glance.
        if (isProductionDeployment(environment, projectId)) return null;

        // Build and target are reported separately on purpose. Which bundle you
        // are running and which backend it talks to are different facts, and a
        // mismatch between them is exactly what this banner exists to surface.
        const usingEmulators = environment === "LOCAL";
        const build = BUILD_LABELS[environment] || environment || "Unknown";
        const target = usingEmulators ? "Emulator" : targetLabel(projectId);

        const modifier = TARGET_STYLES[target] || "env-production";

        let message = this._localisationService().getString("env_notification", { build, target });

        // Staging is publicly reachable, so someone who has landed here by
        // mistake gets a way out. Emulator builds are developer-only, and a
        // production target means they are already on the live data.
        if (target === "Staging") {
            message += ` ${this._localisationService().getString("env_notification_live_site")}`;
        }

        return (
            <div className={`notification-container ${modifier} full-width flexbox`}>
                <p>{HtmlParse(message)}</p>
            </div>
        )
    }
    
    _localisationService() {
        return this.context
    }
}